export function getAuthApiBase() {
    const config = window.__RUNTIME_CONFIG__ || {};
    if (config.REACT_APP_AUTH_API_URL) {
        const url = config.REACT_APP_AUTH_API_URL;
        return url.endsWith('/') ? url : `${url}/`;
    }
    const root = window.ApiURL || '';
    return root.endsWith('/') ? `${root}authorization/` : `${root}/authorization/`;
}
